import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { FieldBoundaries } from "../FieldBoundaries";

    export class PenaltyGoalKeeper extends Phaser.Sprite {

        private static HORIZONTAL_SPEED: number = 200;

        public canBeHit: boolean;

        private textureIdle: string;
        private textureIdleBlink: string;
        private textureSave: string;
        private textureGoal: string;

        private updateAllowed: boolean;

        private leftLimitOnPenalty: number;
        private rightLimitOnPenalty: number;

        constructor(game: Phaser.Game, x: number, y: number) {

            super( game, x, y, "" + GameVars.adversaryID);

            this.canBeHit = true;
            this.updateAllowed = true;

            let adversaryID = GameVars.adversaryID;

            let idle_eyes_open_frame_ID = (adversaryID - 1) * 4 + 1;
            let idle_blink_frame_ID = (adversaryID - 1) * 4 + 2;
            let on_save_fame_ID  = (adversaryID - 1) * 4 + 3;
            let on_goal_frame_ID = (adversaryID - 1) * 4 + 4;

            this.textureIdle = "portero_" +  GameVars.formatNumberForTextureAtlas(idle_eyes_open_frame_ID);
            this.textureIdleBlink  =  "portero_" + GameVars.formatNumberForTextureAtlas(idle_blink_frame_ID);
            this.textureSave   =  "portero_" + GameVars.formatNumberForTextureAtlas(on_save_fame_ID);
            this.textureGoal  = "portero_" + GameVars.formatNumberForTextureAtlas(on_goal_frame_ID);

            this.frameName = this.textureIdle;

            this.game.physics.p2.enable(this, GameConstants.SHOW_PHYSICS_BODIES);

            this.alpha = GameConstants.ALPHA_PHYSICS_BODIES;

            this.anchor.set(.5);

            this.body.clearShapes();

            this.body.addPolygon([true, true, true], [
                20, 35,
                50, 5,
                93.5, 0,
                137, 5,
                167, 35,
                167, 85,
                20, 85
            ]);

            this.body.allowGravity = false;
            this.body.allowRotation = false;
            this.body.setZeroVelocity();
            this.body.data.type = Phaser.Physics.P2.Body.KINEMATIC;
            this.body.angularVelocity = 0;
            this.body.fixedRotation = true;
            this.body.setZeroDamping();
            this.body.setMaterial(GameVars.getInstance().materials.goalkeeperMaterial);
            this.body.mass = 10e8;

            this.body.velocity.x = PenaltyGoalKeeper.HORIZONTAL_SPEED;

            this.name = GameConstants.GOALKEEPER;

            // los limites por donde se mueve cuando hay penalty
            this.leftLimitOnPenalty  = FieldBoundaries.LEFT_POST_PX;
            this.rightLimitOnPenalty = FieldBoundaries.LEFT_POST_PX + FieldBoundaries.DELTA_X_POST;

            this.game.time.events.add(1000, this.blink, this);
        }

        public update(): void {

            let speedFactor: number;

            if ( this.x >  this.rightLimitOnPenalty) {

                speedFactor = Math.random() + 1 ;

                this.body.velocity.x = - PenaltyGoalKeeper.HORIZONTAL_SPEED * speedFactor;

                if (Math.random() > .75) {
                    this.leftLimitOnPenalty = FieldBoundaries.LEFT_POST_PX;
                } else {
                    this.leftLimitOnPenalty = FieldBoundaries.LEFT_POST_PX +
                    Math.random() * .4 * FieldBoundaries.DELTA_X_POST ;
                }
            }

            if ( this.x <  this.leftLimitOnPenalty ) {

                speedFactor = Math.random() + 1;

                this.body.velocity.x = PenaltyGoalKeeper.HORIZONTAL_SPEED *  speedFactor;

                if (Math.random() > .75) {
                    this.rightLimitOnPenalty = FieldBoundaries.LEFT_POST_PX + FieldBoundaries.DELTA_X_POST;
                } else {
                    this.rightLimitOnPenalty = FieldBoundaries.LEFT_POST_PX +
                    FieldBoundaries.DELTA_X_POST  * (.6 + .4 * Math.random()) ;
                }
            }
        }

        public hit(): void {

            this.frameName = this.textureSave;
            this.game.time.events.add(350, this.restart, this);
        }

        public onGoal(): void {

            this.body.velocity.x = 0;
            this.frameName = this.textureGoal;
        }

        public blink(): void {

            if ( this.frameName !== this.textureIdle ) {
                return;
            }

            this.frameName = this.textureIdleBlink;

            this.game.time.events.add( 100, this.returnToIdle, this);
        }

        private restart(): void {

            if ( this.frameName !== this.textureIdle ) {
                this.frameName = this.textureIdle;
            }
        }

        private returnToIdle(): void {

            this.frameName = this.textureIdle;
            this.game.time.events.add(Math.floor(Math.random() * 2500) + 1000, this.blink, this);
        }
    }
